(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/draws/assets/javascripts/vikinglotto-draw.js') >= 0) return;  svs.modules.push('/components/numbergames/draws/assets/javascripts/vikinglotto-draw.js');

'use strict';

const productMapping = svs.numbergames.productMapping;

class VikinglottoDraw extends svs.numbergames.draws.Draw {
  constructor() {
    super({
      productDrawId: productMapping.getProductDrawId(productMapping.CONSTANTS.VIKINGLOTTO)
    });
  }
}
svs.numbergames.draws.VikinglottoDraw = VikinglottoDraw;

 })(window);